import {
  Avatar,
  useChannelStateContext,
  useChatContext,
  useTypingContext,
} from 'stream-chat-react'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { ScreenBar } from './Screen'

// A thread's top bar on a phone: back to the list, who the thread is with
// (or that they're typing), and their picture, which opens their profile as
// the name does. The desktop header's actions are on the profile.
const PhoneChannelHeader = ({ onBack, onProfile }) => {
  const { client } = useChatContext()
  const { channel } = useChannelStateContext()
  const { typing = {} } = useTypingContext()

  const user = Object.values(channel.state.members).find(
    (member) => member.user?.id !== client.userID
  )?.user
  const typingNow = Object.values(typing).some(
    (event) => event.user?.id !== client.userID
  )

  return (
    <ScreenBar onBack={onBack} label="Back to chats">
      <ButtonBase
        onClick={onProfile}
        sx={{
          flex: 1,
          minWidth: 0,
          justifyContent: 'flex-start',
          textAlign: 'left',
          borderRadius: 1,
          py: 0.5,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography noWrap sx={{ fontWeight: 700, lineHeight: 1.3 }}>
            {channel.data.name || user?.name}
          </Typography>
          <Typography
            noWrap
            variant="caption"
            component="div"
            color="text.secondary"
          >
            {typingNow ? 'typing…' : user?.username && `@${user.username}`}
          </Typography>
        </Box>
      </ButtonBase>
      <IconButton aria-label="Profile" onClick={onProfile} sx={{ p: 0.5 }}>
        <Avatar image={user?.image} name={user?.name} size={36} />
      </IconButton>
    </ScreenBar>
  )
}

export default PhoneChannelHeader
